module.exports = __webpack_public_path__ + "static/media/team-3.ea8859e1.png";